export default "__VITE_ASSET__1eefbac8__"